module.exports = __webpack_public_path__ + "img/cart.1cb8827f.png";